/*
  Ruma Match - merkezi ayarlar.
  Level'lar, skor, power-up gucleri, Coin ekonomisi ve oduller sadece buradan degisir.
  Ayni dosya hem tarayicida (tema) hem sunucuda (Vercel, api/oyun.js) kullanilir:
  sunucu Coin'i buradaki kurallara gore kendisi hesaplar, tarayicinin soyledigine guvenmez.

  "surum" degisirse yarida kalmis oyunlar gecersiz sayilir (level tanimi degismis olabilir).
*/
(function (kok, fabrika) {
  if (typeof module === 'object' && module.exports) module.exports = fabrika();
  else kok.RumaMatchAyar = fabrika();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Level meyve havuzlari
  var M4 = ['muz', 'karpuz', 'ananas', 'mango'];
  var M5 = M4.concat('uzum');
  var M6 = M5.concat('kivi');

  var ayar = {
    surum: 2,

    tahta: { en: 6, boy: 6 },

    // Sira onemli: motor meyveleri bu siradaki indeksle tutar. Yeni meyve hep sona eklenir.
    // Her level "meyveler" ile kendi havuzunu secer; yazmazsa ilk 4'u kullanilir.
    meyveler: ['muz', 'karpuz', 'ananas', 'mango', 'uzum', 'kivi', 'cilek', 'limon', 'nar', 'seftali'],
    meyveAdlari: {
      muz: 'Muz', karpuz: 'Karpuz', ananas: 'Ananas', mango: 'Mango', uzum: 'Üzüm',
      kivi: 'Kivi', cilek: 'Çilek', limon: 'Limon', nar: 'Nar', seftali: 'Şeftali'
    },

    skor: {
      eslesme3: 60,        // 3'lu
      eslesme4: 120,       // 4'lu -> roket
      sekilLT: 160,        // L / T -> bomba
      eslesme5: 220,       // 5'li -> gunes
      ozelParca: 20,       // power-up'in temizledigi her ek parca
      kombo: 400,          // iki power-up birlesince
      kalanHamle: 250,     // level bitince kalan her hamle
      carpanMax: 5         // zincir carpani x1, x2 ... en fazla bu
    },

    guc: {
      bombaYaricap: 2,       // bomba: elmas bicimli alan (2 = 13 kare)
      bombaBombaYaricap: 3,  // bomba + bomba: 7x7 kare
      roketBombaGenislik: 1  // roket + bomba: ortadaki satir/sutun +/- 1 (3 satir + 3 sutun)
    },

    ekonomi: {
      aylikLimit: 1000,          // ay icinde oyundan kazanilabilecek en fazla Coin (harcamak limiti acmaz)
      // Gunluk tavan yok: oyuncu butun level'lari tek oturusta bitirebilmeli.
      // Her level'in Coin'i bir kez verilir (ilk gecis + sonradan eklenen yildizlar), tekrar oynamak Coin kasmaz.
      // 20 level'in hepsi 3 yildiz = 1000 Coin: en buyuk odul oyunun sonunda gelir. Level eklenince toplami yeniden hesapla.
      gecisCoin: [[5, 14], [10, 22], [15, 30], [20, 38]], // level gecince: [bu level'a kadar, Coin]; zor level daha cok verir
      yildizBasina: 8,           // + her yildiz icin (tekrar oynayinca sadece yeni yildizlar)
      minHamleSuresiMs: 600,     // bundan hizli oynanan oyun sahte sayilir, Coin vermez
      oyunGecerlilikDk: 120,     // baslatilan level bu surede bitmezse gecersiz
      saatDilimi: 'Europe/Istanbul'
    },

    // minSepet: kodun gecerli olmasi icin en az sepet tutari (TL). Yazilmazsa sinir yok.
    oduller: [
      { id: 'indirim-200tl', coin: 150, baslik: '200 TL indirim', aciklama: '500 TL ve üzeri sepette 200 TL indirim.', baslik_en: '200 TL off', aciklama_en: '200 TL off on carts of 500 TL and above.', tur: 'sabit', deger: 200, minSepet: 500, aktif: true },
      { id: 'ikinci-urun-50', coin: 250, baslik: 'İkinci ürüne %50', aciklama: 'Aynı üründen ikincisine %50 indirim.', baslik_en: '50% off the second item', aciklama_en: '50% off the second item of the same product.', tur: 'ikinci-urun', deger: 0.5, aktif: false },
      { id: 'sepet-25', coin: 500, baslik: 'Sepete %25', aciklama: 'Sepet toplamına %25 indirim.', baslik_en: '25% off your cart', aciklama_en: '25% off the cart total.', tur: 'yuzde', deger: 0.25, aktif: true },
      { id: 'sepet-35', coin: 1000, baslik: 'Sepete %35', aciklama: 'Sepet toplamına %35 indirim.', baslik_en: '35% off your cart', aciklama_en: '35% off the cart total.', tur: 'yuzde', deger: 0.35, aktif: true }
    ],
    odulKodGecerlilikGun: 30,

    /*
      Hikaye bolumleri: leveller mekanik olarak degismiyor, sadece anlam katmani.
      "son": bu bolumun bitis level'i. Her bolum, o araliktaki level'larda tanisilan
      yeni mekanigin (power-up, buz, kutu, sarmasik) etrafina kurulu.
      "giris": bolumun ilk level'inde gosterilir. "kutlama": bolumun son level'i ilk kez
      gecildiginde gosterilir (bolum bitis ekrani).
    */
    bolumler: [
      { ad: 'Çakıl Plaj', ad_en: 'Pebble Beach', son: 3, giris: 'Güneş daha uykuda, koy sessiz. İlk meyveleri topla, ışığı uyandırmaya başla.', kutlama: 'Çakıl Plaj\'a ilk ışık düştü, kumsal parlamaya başladı.', giris_en: 'The sun is still asleep, the cove is quiet. Collect the first fruits and start waking up the light.', kutlama_en: 'The first light fell on Pebble Beach, and the shore began to glow.' },
      { ad: 'Liman Şenliği', ad_en: 'Harbor Festival', son: 6, giris: 'Limanda şenlik başlıyor. Roket, bomba, güneş patlamaları artık elinde.', kutlama: 'Liman ışıkla doldu, tekneler denize açıldı.', giris_en: 'A festival is starting at the harbor. Rocket, bomb and sun blasts are now in your hands.', kutlama_en: 'The harbor filled with light and the boats set out to sea.' },
      { ad: 'Soğuk Rüzgar', ad_en: 'Cold Wind', son: 9, giris: 'Sabah rüzgarı meyveleri dondurmuş. Buzu kır, koyu ısıt.', kutlama: 'Buzlar eridi. Koy ılık bir yaz sabahına uyandı.', giris_en: 'The morning wind has frozen the fruits. Break the ice and warm the cove.', kutlama_en: 'The ice has melted. The cove woke up to a warm summer morning.' },
      { ad: 'Eski Pazar', ad_en: 'Old Market', son: 14, giris: 'Eski pazarın tozlu sandıkları ve sarmaşıkları seni bekliyor.', kutlama: 'Pazar tezgahları yeniden meyve ve renkle doldu.', giris_en: 'The dusty crates and vines of the old market are waiting for you.', kutlama_en: 'The market stalls filled with fruit and color again.' },
      { ad: "Ruma Koyu'nun Uyanışı", ad_en: "Ruma Village Awakens", son: 20, giris: 'Son duraktasın. Bütün koy şimdi elinde, güneşi tam doğuşuna taşı.', kutlama: 'Güneş tam doğdu. Ruma Koyu artık yazın enerjisiyle parlıyor.', giris_en: 'You are at the final stop. The whole cove is in your hands now, carry the sun to its full rise.', kutlama_en: 'The sun has fully risen. Ruma Village now shines with the energy of summer.' }
    ],

    /*
      Level tanimi:
        hamle    : hamle sayisi
        meyveler : tahtada hangi meyveler var (yazilmazsa ilk 4). Meyve arttikca level zorlasir:
                   4 meyve cok zincir yapar (kolay), 5 dengeli, 6 zor.
        hedef    : { muz: 20 } meyve toplama | { roket: 2, bomba: 1, gunes: 1 } power-up patlatma
                   { buz: true, kutu: true, sarmasik: true } tahtadakilerin hepsini temizle | { skor: 5000 }
        yildiz   : [2 yildiz icin kalan hamle, 3 yildiz icin kalan hamle]  (level gecmek = 1 yildiz).
                   Hamle ve yildiz sayilari oyun/denge.mjs olcumunden gelir; level degisince yeniden olc.
        duzen    : 6 satir x 6 karakter. '.' bos kare, 'i' buz, 'I' kalin buz (2 vurus),
                   'k' kutu, 'K' saglam kutu (2 vurus), 's' sarmasik, 'g' hazir gunes
        ipucu    : level basinda kisa aciklama
    */
    leveller: [
      { hamle: 19, hedef: { muz: 30 }, yildiz: [9, 12], ipucu: 'Yan yana iki meyvenin yerini değiştir, aynı meyveden 3 tane diz.', ipucu_en: 'Swap two neighboring fruits and line up 3 of the same fruit.' },
      { hamle: 23, hedef: { karpuz: 36 }, yildiz: [12, 15] },
      { hamle: 20, hedef: { ananas: 35, mango: 35 }, yildiz: [9, 12] },
      { hamle: 22, hedef: { roket: 2 }, yildiz: [13, 17], ipucu: '4 aynı meyveyi yan yana diz: roket çıkar. Roketi bir meyveyle kaydır ya da üstüne iki kez dokun, bütün sırayı temizler.', ipucu_en: 'Line up 4 of the same fruit: a rocket appears. Slide the rocket with a fruit or double-tap it, and it clears the whole row.' },
      { hamle: 24, hedef: { bomba: 1, muz: 32 }, yildiz: [14, 17], ipucu: 'L ya da T şeklinde 5 meyve: bomba çıkar. Bombayı kaydır ya da üstüne iki kez dokun, etrafını temizler.', ipucu_en: '5 fruits in an L or T shape: a bomb appears. Slide the bomb or double-tap it, and it clears the area around it.' },
      {
        hamle: 19, hedef: { gunes: 1, karpuz: 40 }, yildiz: [8, 11], ipucu: 'Güneşi bir meyveyle yer değiştir: o meyvenin hepsi gider. 5 aynı meyveyi düz sıraya dizersen yeni güneş çıkar.', ipucu_en: 'Swap the sun with a fruit: every fruit of that kind disappears. Line up 5 of the same fruit in a straight row to make a new sun.',
        duzen: ['......', '......', '..g...', '......', '......', '......']
      },
      {
        hamle: 15, meyveler: M5, hedef: { buz: true }, yildiz: [8, 10], ipucu: 'Buzun üstünde eşleşme yap, buz kırılır.', ipucu_en: 'Make a match on top of the ice and the ice breaks.',
        duzen: ['......', '.iiii.', '.iiii.', '.iiii.', '.iiii.', '......']
      },
      { hamle: 23, meyveler: M5, hedef: { karpuz: 19, mango: 19 }, yildiz: [8, 12] },
      {
        hamle: 31, meyveler: M5, hedef: { buz: true }, yildiz: [14, 18],
        duzen: ['.iiii.', 'ii..ii', 'i.ii.i', 'i.ii.i', 'ii..ii', '.iiii.']
      },
      {
        hamle: 18, meyveler: M5, hedef: { kutu: true }, yildiz: [6, 9], ipucu: 'Kutunun yanında eşleşme yap ya da power-up ile vur, kutu açılır.', ipucu_en: 'Make a match next to the crate or hit it with a power-up, and the crate opens.',
        duzen: ['......', '.kkkk.', '.kKKk.', '.kKKk.', '.kkkk.', '......']
      },
      { hamle: 23, meyveler: M5, hedef: { muz: 22, ananas: 22 }, yildiz: [6, 10] },
      {
        hamle: 22, meyveler: M5, hedef: { sarmasik: true }, yildiz: [11, 15], ipucu: 'Sarmaşıklı meyve yerinden oynamaz. Onu bir eşleşmeye kat, sarmaşık kopar.', ipucu_en: 'A vine-wrapped fruit does not move. Include it in a match and the vine breaks.',
        duzen: ['......', 's....s', '.s..s.', '..ss..', '.s..s.', '......']
      },
      {
        hamle: 16, meyveler: M5, hedef: { buz: true, kutu: true }, yildiz: [7, 10],
        duzen: ['......', 'k....k', 'kIIIIk', 'kIIIIk', '......', '......']
      },
      { hamle: 27, meyveler: M6, hedef: { mango: 15, karpuz: 15 }, yildiz: [8, 12] },
      {
        hamle: 35, meyveler: M5, hedef: { buz: true }, yildiz: [11, 17],
        duzen: ['..II..', '.I..I.', 'I.ii.I', 'I.ii.I', '.I..I.', '..II..']
      },
      {
        hamle: 23, meyveler: M5, hedef: { kutu: true, muz: 24 }, yildiz: [5, 10],
        duzen: ['......', 'KK..KK', '......', '..KK..', '......', '......']
      },
      {
        hamle: 25, meyveler: M5, hedef: { sarmasik: true, buz: true }, yildiz: [11, 16],
        duzen: ['.s..s.', '..ii..', 's.ii.s', 's.ii.s', '..ii..', '.s..s.']
      },
      { hamle: 30, meyveler: M5, hedef: { roket: 2, muz: 28 }, yildiz: [8, 13] },
      {
        hamle: 19, meyveler: M5, hedef: { buz: true, kutu: true, sarmasik: true }, yildiz: [8, 11],
        duzen: ['k....k', '.s..s.', '.IiiI.', '.iKKi.', '.s..s.', 'k....k']
      },
      {
        hamle: 30, meyveler: M5, hedef: { buz: true, kutu: true }, yildiz: [11, 16],
        duzen: ['KiiiiK', '.I..I.', '.IkkI.', '.IkkI.', '.I..I.', 'KiiiiK']
      }
    ]
  };

  // Level gecince verilen taban Coin (ekonomi.gecisCoin tablosundan)
  ayar.gecisCoini = function (level) {
    var t = ayar.ekonomi.gecisCoin;
    for (var i = 0; i < t.length; i++) if (level <= t[i][0]) return t[i][1];
    return t[t.length - 1][1];
  };

  // Level'in ait oldugu hikaye bolumu: { i, ad, giris, kutlama, bas (ilk level), son (son level) }
  ayar.bolumBilgi = function (level) {
    var liste = ayar.bolumler, i;
    for (i = 0; i < liste.length - 1; i++) if (level <= liste[i].son) break;
    var bas = i === 0 ? 1 : liste[i - 1].son + 1;
    var en = typeof document !== 'undefined' && document.documentElement.lang !== 'tr';
    return { i: i, ad: en ? (liste[i].ad_en || liste[i].ad) : liste[i].ad, giris: en ? (liste[i].giris_en || liste[i].giris) : liste[i].giris, kutlama: en ? (liste[i].kutlama_en || liste[i].kutlama) : liste[i].kutlama, bas: bas, son: liste[i].son };
  };

  return ayar;
});
